import DayTickFormatter from './component';

export default DayTickFormatter;
